export default {"src":"/_next/static/media/ic-search.8b258b23.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};